import Header from "./global/_header";
import Footer from "./global/_footer";
import Home from "./pages/_home";
import MainProduct from "./pages/_main-product";
import Blog from "./pages/_blog";
import OurPhilosophy from "./pages/_our-philosophy";
import AllCollections from "./pages/_all-collections";


'use strict';
new Header();
new Footer();
new Home();
new MainProduct();
new Blog();
new OurPhilosophy();
new AllCollections();
